
import '../Services.css';
import img from '../../../assets/catogory/Commercial_Plots/img1.jpg'; // Marketing/Commercial image
import PropertyAdvantage from '../../../components/PropertyAdvantage/PropertyAdvantage';
import ConversationSection from '../../../components/ConversationSection/ConversationSection';

const MarketingManagement = () => {
    return (
        <div className="service-page">
            <div className="service-hero">
                <h1>Marketing & Management</h1>
            </div>
            <section className="service-split-section">
                <div className="service-split-container">
                    <div className="service-left">
                        <span className="service-badge-pill">Success, Together</span>
                        <h2 className="service-split-title">Marketing & Management</h2>
                        <p className="service-split-text">
                            At Jeevan Realty, we simplify every aspect of property marketing—whether you are launching a new project or selling an individual unit. Our data-driven strategies and comprehensive management ensure maximum visibility, transparency, and successful closures.
                        </p>
                    </div>
                    <div className="service-right">
                        <img src={img} alt="Marketing Management" />
                    </div>
                </div>
            </section>

            <div className="service-steps-container">
                <div className="service-steps-list">
                    {/* Step 1 */}
                    <div className="service-step-card">
                        <div className="service-step-number">1</div>
                        <div className="service-step-content">
                            <h3>Market Research</h3>
                            <p>We analyze market trends, competitor activity, and target demographics to build a solid foundation for your project's marketing.</p>
                        </div>
                    </div>

                    {/* Step 2 */}
                    <div className="service-step-card">
                        <div className="service-step-number">2</div>
                        <div className="service-step-content">
                            <h3>Strategy Development</h3>
                            <p>Our team crafts a tailored marketing strategy, defining unique selling points and selecting the most effective channels.</p>
                        </div>
                    </div>

                    {/* Step 3 */}
                    <div className="service-step-card">
                        <div className="service-step-number">3</div>
                        <div className="service-step-content">
                            <h3>Content Creation</h3>
                            <p>We produce high-quality visual and written content, including brochures, videos, and virtual tours, to showcase your property.</p>
                        </div>
                    </div>

                    {/* Step 4 */}
                    <div className="service-step-card">
                        <div className="service-step-number">4</div>
                        <div className="service-step-content">
                            <h3>Campaign Execution</h3>
                            <p>We launch targeted campaigns across digital and traditional media to generate leads and maximize visibility.</p>
                        </div>
                    </div>

                    {/* Step 5 */}
                    <div className="service-step-card">
                        <div className="service-step-number">5</div>
                        <div className="service-step-content">
                            <h3>Lead Management</h3>
                            <p>Our dedicated team manages inquiries, nurtures leads, and schedules site visits to convert interest into sales.</p>
                        </div>
                    </div>

                    {/* Step 6 */}
                    <div className="service-step-card">
                        <div className="service-step-number">6</div>
                        <div className="service-step-content">
                            <h3>Performance Analysis</h3>
                            <p>We continuously monitor campaign performance and provide detailed reports, optimizing strategies for best results.</p>
                        </div>
                    </div>
                </div>
            </div>

            <PropertyAdvantage />
            <ConversationSection />
        </div >
    );
};

export default MarketingManagement;
